import PWAInstallPrompt from './PWAInstallPrompt';

export default PWAInstallPrompt;

